import i18n, { portalLanguage } from './index';

/**
 * The server answers in English. Its customer-facing refusals carry a stable
 * code (`EMPTY_ORDER`, `INVALID_PHONE`, `RECAPTCHA_FAILED`, …) next to the
 * English sentence; in French or Spanish the code picks the sentence from
 * `errors.server.*` instead. English keeps the server's own words, exactly
 * as before, and so does a code we have no translation for.
 */
export function localizeServerError(
  code: string | null | undefined,
  serverMessage: string,
): string {
  if (portalLanguage() === 'en' || !code) return serverMessage;
  const key = `errors.server.${code}`;
  return i18n.exists(key) ? i18n.t(key) : serverMessage;
}

/**
 * class-validator's English constraint messages (422s). The ones a customer
 * can meet in the booking flow are translated; anything else, in FR/ES,
 * becomes the generic "check the form" sentence rather than English.
 */
const CONSTRAINT_KEYS: [RegExp, string][] = [
  [/must be an email/i, 'errors.constraints.email'],
  [/phone/i, 'errors.constraints.phone'],
  [/should not be empty|must not be empty/i, 'errors.constraints.required'],
  [/password/i, 'errors.constraints.password'],
];

export function localizeConstraint(message: string): string {
  if (portalLanguage() === 'en') return message;
  const hit = CONSTRAINT_KEYS.find(([pattern]) => pattern.test(message));
  return i18n.t(hit ? hit[1] : 'errors.constraints.generic');
}

/**
 * A free-text English message from the server (a 400 from auth/login, a
 * reset link that expired): shown as is in English, and replaced by our own
 * sentence (`fallbackKey`) in French or Spanish.
 */
export function localizeServerMessage(
  serverMessage: string | null | undefined,
  fallbackKey: string,
): string {
  if (portalLanguage() === 'en' && serverMessage) return serverMessage;
  return i18n.t(fallbackKey);
}
